import { render, staticRenderFns } from "./PurchaseDelivery.vue?vue&type=template&id=db6f56fe&scoped=true"
import script from "./PurchaseDelivery.vue?vue&type=script&lang=js"
export * from "./PurchaseDelivery.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDelivery.vue?vue&type=style&index=0&id=db6f56fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6f56fe",
  null
  
)

export default component.exports